import { render, staticRenderFns } from "./ManageProcessContent.vue?vue&type=template&id=2a21a5dd&scoped=true&"
import script from "./ManageProcessContent.vue?vue&type=script&lang=js&"
export * from "./ManageProcessContent.vue?vue&type=script&lang=js&"
import style0 from "./ManageProcessContent.vue?vue&type=style&index=0&id=2a21a5dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21a5dd",
  null
  
)

export default component.exports